export default function prepareRoutesByView (routeDefinitions) {
  let routesByView = {};

  for (let [routePattern, {view, params = {}, choices = {}}] of Object.entries(routeDefinitions.routes)) {
    if (!(view in routesByView)) {
      routesByView[view] = {};
    }
    let paramKeys = Object.keys(params).concat(Object.keys(choices));
    if (!(paramKeys.length in routesByView[view])) {
      routesByView[view][paramKeys.length] = [];
    }
    routesByView[view][paramKeys.length].push({routePattern, paramKeys, singleValueParams: params});
  }
  return routesByView;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/prepareRoutesByView.js